// extracted by mini-css-extract-plugin
export default {"rowsHeader":"InstagramPage_rowsHeader__c+8Zs","pageName":"InstagramPage_pageName__UVdj-","metrics":"InstagramPage_metrics__Blgna","valueTitle":"InstagramPage_valueTitle__Prl7p"};